import { useEffect, useState } from 'react';
import { ChartData } from 'funds-model';
import { getFundsQuotesChartPricing } from '../../api/fundsQuotesApi';

interface UseFundsQuotesChartPricingApiResult {
  data?: ChartData;
  isLoading: boolean;
}

export function useFundsQuotesChartPricingApi(
  fundId: number,
  unitCategory: string,
  fromDate?: string,
  enabled = true,
): UseFundsQuotesChartPricingApiResult {
  const [data, setData] = useState<ChartData>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!enabled || !fromDate) return;
    let subscribed = true;
    setIsLoading(true);
    getFundsQuotesChartPricing(fundId, unitCategory, fromDate).then(response => {
      if (subscribed) {
        setData(response);
        setIsLoading(false);
      }
    });
    return () => { subscribed = false; };
  }, [fundId, unitCategory, fromDate, enabled]);

  return { data, isLoading };
}
